export var KybRequestProcess;
(function (KybRequestProcess) {
    KybRequestProcess["SystemDefaultForm"] = "system-default-form";
    KybRequestProcess["CustomRequestForm"] = "custom-request-form";
    KybRequestProcess["ThirdPartyRedirection"] = "third-party-redirection";
})(KybRequestProcess || (KybRequestProcess = {}));
export var KybRequest;
(function (KybRequest) {
    KybRequest["EntityConstitutionalDocuments"] = "ENTITY_CONSTITUTIONAL_DOCUMENTS";
    KybRequest["RegistryExtract"] = "REGISTRY_EXTRACT";
    KybRequest["EntityGroupOwnershipDiagram"] = "ENTITY_GROUP_OWNERSHIP_DIAGRAM";
    KybRequest["CustomRequest"] = "CUSTOM_REQUEST";
})(KybRequest || (KybRequest = {}));
//# sourceMappingURL=index.js.map